import React, { FC, useCallback, useEffect, useState, useContext, useMemo } from 'react';
import { TasksContext, TasksDispatchContext, TasksProvider, useTask } from '../stateManagement/context';

import { get, post } from "../fetchers/fetchers";
import { get_query } from '../stateManagement/data';

import { useParams } from "react-router";



import {
    Accordion, AccordionSummary, Chip,
    Container, Grid, IconButton, Paper,
    Table, TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    Typography,
    TextField,
    withStyles
} from "@material-ui/core";
import {
    IAdequacy,
    IAssessmentSettings,
    IControlMeasure, IControlMeasureAdequacy, IControlMeasureAssessment, IControlMeasureCost,
    IControlMeasureFailureMode,
    IControlType, ICriticalHazards, IFailureModeAssessment, IHarm,
    IProjectFailureMode,
    IRiskAssessment
} from "../types/types";
import { ExpandMore } from "@material-ui/icons";

import WarningIcon from '@material-ui/icons/Warning';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'; // Import the ExpandMore icon
import ExpandLessIcon from '@material-ui/icons/ExpandLess'; // Import the ExpandMore icon

import ControlMeasures from "./control_measuers";
import { Consequence } from "./harm";
import { Confidence } from "./critical_failure_mode";
import { ControlAssessment } from "./control_measure_adequacy";
import AddIcon from "@material-ui/icons/Add";
import { ControlConcern } from './societal_concern';
import ReasonablyPracticableTest from "./reasonably_practicable_test";
import { render_likelihood_pill } from "./likelihood";
import AddControlMeasureDialog from "./add_ccontrol_measure_dialog";


import { getControlMeasures, getFailureModeControlMeasures, getControlMeasureAssessment, getFailureModeAssessments, getControlMeasureCosts } from "../stateManagement/data";
import { APPLICATION } from "../env";
import { API_URL } from "../env";

interface IRenderCategoryProps {
    f: IProjectFailureMode;
    expanded: string | false;
    considered: boolean;
    additional: boolean;
    existing: boolean;
    control_view?: boolean;
    handleChange: (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => void;
}

interface IRouteParams {
    id: string
}

export const WarningChip = (name: string, inital_level?: number, tool_tip_label?: string) => {

    let level = -1;
    if (inital_level) {
        level = inital_level;
    }
    let alpha = 1
    let color = "#535353"
    let bcolor = "rgb(196,196,196)";
    if (level) {
        if (level === 4) {
            bcolor = "rgba(0,176,80," + alpha + ")";
            color = "rgb(0,0,0)";

        }
        if (level === 3) {
            bcolor = "rgba(206,238,208," + alpha + ")";
            color = "rgb(48,104,33)";

        }
        if (level === 2) {
            bcolor = "rgba(252,236,166," + alpha + ")";
            color = "rgb(152,96,34)";

        }
        if (level === 1) {
            bcolor = "rgba(251,84,81," + alpha + ")";
            color = "rgb(104,4,0)";

        }

    }


    if (tool_tip_label === undefined) {
        tool_tip_label = "Not enough data for assessment"
    }


    return (
        <div>
            <Tooltip title={tool_tip_label}>
                <Chip
                    icon={<WarningIcon />}
                    size="small"
                    label={name}
                    color="primary"
                    style={{ backgroundColor: bcolor, color: color }}
                />
            </Tooltip>
        </div>
    )
}

const AddingButton = withStyles(theme => ({
    root: {
        margin: "auto",
        backgroundColor: "rgba(0,103,114,0.2)",
        color: "rgba(0,103,114,1)",
        '&:hover': {
            backgroundColor: "rgba(0,103,114,0.5)",
        },
    },
}))(IconButton);

export const RenderCategory: FC<IRenderCategoryProps> = ({ f, expanded, handleChange, considered, additional, existing, control_view=false }) => {

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [controlTypes, setControlTypes] = useState<IControlType[]>([]);
    const [controlMeasures, setControlMeasures] = useState<IControlMeasure[]>([]);
    const [adequacies, setAdequacies] = useState<IAdequacy[]>([]);
    const [failureModes, setFailureModes] = useState<IProjectFailureMode[]>([]);
    const [controlMeasureAssessments, setControlMeasureAssessments] = useState<IControlMeasureAssessment[]>([]);
    const [controlMeasureFailureModes, setControlMeasureFailureModes] = useState<IControlMeasureFailureMode[]>([]);
    const [harms, setHarms] = useState<IHarm[]>([]);
    const [riskAssessments, setRiskAssessments] = useState<ICriticalHazards[]>([]);
    const [controlMeasureAdequacies, setControlMeasureAdequacies] = useState<IControlMeasureAdequacy[]>([]);
    const [controlMeasureConcerns, setControlMeasureConcerns] = useState<IControlMeasureAdequacy[]>([]);
    const [failureModeAssessments, setFailureModeAssessments] = useState<IFailureModeAssessment[]>([]);
    const [write_access, setWriteAccess] = useState<boolean>(false);
    const [FMFilter, setFMFilter] = useState<string | null>(null);
    const [expandedHeader, setExpandedHeader] = useState<boolean>(true);
    const [settings, setSettings] = useState<IAssessmentSettings | null>(null);

    let dispatch = useContext(TasksDispatchContext)
    let tasks = useTask()

    const params = useParams<IRouteParams>()

    useEffect(() => {
        if (tasks.loaded) {
            setFailureModes(tasks.failureModes);
        }
    }, [tasks.failureModes, tasks.loaded]);


    useEffect(() => {
        if (tasks.loaded) {
            setAdequacies(tasks.adequacies);
        }
    }, [tasks.adequacies, tasks.loaded]);

    useEffect(() => {
        if (tasks.loaded) {
            setControlMeasures(tasks.controlMeasures);
        }
    }, [tasks.controlMeasures, tasks.loaded]);


    useEffect(() => {
        if (tasks.loaded) {
            setControlMeasureAdequacies(tasks.controlMeasureAdequacy);
            setSettings(tasks.assessmentSettings);
            setControlMeasureConcerns(tasks.controlMeasureConcern);
        }
    }, [tasks.controlMeasureAdequacy, tasks.controlMeasureConcern, tasks.assessmentSettings, tasks.loaded]);

    useEffect(() => {
        if (tasks.loaded) {
            setControlTypes(tasks.controlTypes);
        }
    }, [tasks.controlTypes, tasks.loaded]);

    useEffect(() => {
        if (tasks.loaded) {
            setRiskAssessments(tasks.criticalHazards);
            setHarms(tasks.harms);
        }
    }, [tasks.criticalHazards, tasks.harms, tasks.loaded]);

    useEffect(() => {
        if (tasks.loaded) {
            setControlMeasureFailureModes(tasks.failureModeControlMeasures);
            setControlMeasureAssessments(tasks.controlMeasureAssessments);
            setFailureModeAssessments(tasks.failureModeAssessments);

            setCurrentFailureModeAssessment(
                // Use the find result directly if found, otherwise use the fallback object

                tasks.failureModeAssessments.find(fma => fma.project_failure_mode_id === f.id) || {
                    project_failure_mode_id: f.id || -1, // Ensure this is always defined and matches the expected type in IFailureModeAssessment
                    assessment: "", // Provide default values for the rest of the properties
                }
            )
        }
    }, [tasks.failureModeControlMeasures, tasks.failureModeAssessments, tasks.controlMeasureAssessments, tasks.loaded]);



    useEffect(() => {
        setWriteAccess(tasks.write_access)
    }, [tasks.write_access])



    let harm = harms.find(h => h.project_failure_mode_id === f.id);
    let critical_hazard = riskAssessments.find(h => h.project_failure_mode_id === f.id);
    let ec = controlMeasureAdequacies.find(a => a.project_failure_mode_id === f.id)
    let cc = controlMeasureConcerns.find(a => a.project_failure_mode_id === f.id)


    const handleHeaderExpand = () => {
        setExpandedHeader(!expandedHeader); // Toggle the header expansion state
    };

    const [openCreateDialog, setOpenCreateDialog] = useState<boolean>(false);
    const [currentFailureModeAssessment, setCurrentFailureModeAssessment] = useState<IFailureModeAssessment>(
        // Use the find result directly if found, otherwise use the fallback object
        failureModeAssessments.find(fma => fma.project_failure_mode_id === f.id) || {
            project_failure_mode_id: f.id || -1, // Ensure this is always defined and matches the expected type in IFailureModeAssessment
            assessment: "", // Provide default values for the rest of the properties
        }
    );


    const postFailureModeAssessment = async (failure_mode_assessment: IFailureModeAssessment) => {
        delete failure_mode_assessment.id
        delete failure_mode_assessment.assessment_project_id
        const assessments = await post<IFailureModeAssessment>(API_URL + "failure_modes/" + params.id + "/assessment", failure_mode_assessment);
        let e = await getFailureModeAssessments(params.id, dispatch)

    }

    const handleClose = () => {
        setOpenCreateDialog(false)
    }
    const handleOpen = () => {
        setOpenCreateDialog(true)
    }

    const getCMeasureAssessment = (cm: IControlMeasure, pf: IProjectFailureMode): IControlMeasureAssessment => {
        if (!pf.id) {
            throw new Error("Project Failure Mode id is not defined")
        }
        let cm_id = cm.uuid
        if (!cm_id)
            cm_id = -1

        let controlMeasureAssessment = controlMeasureAssessments.find(cma => cma.control_measure_id === cm_id && pf.id == cma.project_failure_mode_id)

        if (controlMeasureAssessment) {
            return controlMeasureAssessment
        }
        controlMeasureAssessment = {
            control_measure_id: cm_id,
            project_failure_mode_id: pf.id
        }
        return controlMeasureAssessment
    }

    const setControlMeasureAssessment = async (controlMeasureAssessment: IControlMeasureAssessment) => {
        delete controlMeasureAssessment.id
        let d = await post<IControlMeasureAssessment>(API_URL + "control_measures/" + params.id.toString() + "/assessments", controlMeasureAssessment);
        let e = getControlMeasureAssessment(params.id, dispatch)
    }


    const updateControlMeasureAssessmentFinal = useCallback((controlMeasureAssessment: IControlMeasureAssessment) => {
        setControlMeasureAssessment(controlMeasureAssessment);
    }, [setControlMeasureAssessment]);


    const postCM = async (controlMeasure: IControlMeasure) => {
        let cm = { ...controlMeasure };
        delete cm.document;
        delete cm.id;

        // check if states in params
        let query_params = get_query()

        // check if state key in params
        if (query_params.state) {
            cm["state_id"] = parseInt(query_params.state)
        }
        const d = await post<IControlMeasure>(API_URL + "control_measures/" + params.id.toString() + "/", cm)

        const e = await getControlMeasures(params.id, dispatch)

    }


    const updateControlMeasure = useCallback((controlMeasure: IControlMeasure) => {
        postCM(controlMeasure).then(() => {
        })
    }, []);


    const postControlMeasure = async (controlMeasure: IControlMeasure) => {
        let cm = { ...controlMeasure };
        delete cm.document;
        delete cm.id;

        // check if states in params
        let query_params = get_query()

        // check if state key in params
        if (query_params.state) {
            cm["state_id"] = parseInt(query_params.state)
        }
        const d = await post<IControlMeasure>(API_URL + "control_measures/" + params.id.toString() + "/", cm)
        const e = await getControlMeasures(params.id, dispatch)

        return d


    }
    const MemoizedReasonablyPracticableTest = React.memo(ReasonablyPracticableTest);

    const setFailureModeControlMeasures = async (failureModeControlMeasure: IControlMeasureFailureMode) => {
        let d = await post<IControlMeasureFailureMode>(API_URL + "control_measures/failure_modes", failureModeControlMeasure);
        let e = getFailureModeControlMeasures(params.id, dispatch)
    }

    const updateFailureModeControlMeasures = useCallback((failureModeControlMeasures: IControlMeasureFailureMode) => {
        setFailureModeControlMeasures(failureModeControlMeasures).then(() => {
        })
    }, [setFailureModeControlMeasures]);


    const updateControlMeasures = useCallback((controlMeasure: IControlMeasure, failure_mode_id?: number) => {
        postControlMeasure(controlMeasure).then((cm) => {
            updateFailureModeControlMeasures({
                control_measure_id: cm.uuid,
                project_failure_mode_id: failure_mode_id || -1,
                priority: 1
            })
        }).then(() => {
        })
    }, [postControlMeasure]);

    const render_pill = (level: number, label: string, trigger: string | null) => {
        let color = "#535353";
        let alpha = FMFilter === trigger ? 1 : 0.1;
        let bcolor = "rgb(196,196,196," + alpha + ")";

        if (level === 3) {
            bcolor = "rgba(206,238,208," + alpha + ")";
            color = "rgb(48,104,33)";
        }
        if (level === 2) {
            bcolor = "rgba(206,238,208," + alpha + ")";
            color = "rgb(48,104,33)";
        }
        if (level === 1) {
            bcolor = "rgba(252,236,166," + alpha + ")";
            color = "rgb(152,96,34)";
        }
        if (level === 0) {
            bcolor = "rgba(251,84,81," + alpha + ")";
            color = "rgb(104,4,0)";
        }

        const chipStyle = {
            backgroundColor: bcolor,
            color: color,
            borderColor: color // Set the border color same as text color
        };

        return (
            <Tooltip title={label}>
                <Chip
                    size="small"
                    label={label}
                    style={chipStyle}
                    onClick={() => setFMFilter(trigger)}
                    variant={FMFilter === trigger ? "default" : "outlined"}
                />
            </Tooltip>
        );
    }

    const checkIfPrimary = (cm: IControlMeasure) => {
        // find all linked failure modes
        let linked = controlMeasureFailureModes.filter(cmf => cm.uuid === cmf.control_measure_id)
        // check if any of the linked failure modes  are considered
        let considered = linked.filter(cmf => {
            let fma = failureModeAssessments.find(fma => fma.project_failure_mode_id === cmf.project_failure_mode_id)
            if (fma && fma.consider) {
                return true
            }
            return false
        })
        return considered.length > 0
    }




    const render_control_measure_assessment = useMemo(() => {
        // Extract only the relevant control measures based on the project failure mode id and priority
        const relevantControlMeasures = controlMeasureFailureModes.filter((cf) =>
            cf.project_failure_mode_id === f.id && cf.priority > 0);




        return relevantControlMeasures.sort((a, b) => {
            let cm_a = controlMeasures.filter((c) => c.existing === existing).find(c => c.uuid === a.control_measure_id)
            let cm_b = controlMeasures.filter((c) => c.existing === existing).find(c => c.uuid === b.control_measure_id)
            return (cm_a?.order || 1000000) - (cm_b?.order || 1000000);

        }
        ).map((cf) => {
            // Find corresponding control measures
            let cm = controlMeasures.filter((c) => c.existing === existing).find(c => c.uuid === cf.control_measure_id);

            if (!cm) {
                return <></>; // Return empty fragment if no control measure found
            }

            let cma = getCMeasureAssessment(cm, f);
            if (!cma) {
                return <></>; // Return empty fragment if no control measure assessment found
            }

            if (!cma.considered && !cma.de_minimis && !additional) {
                return <></>; // Return empty fragment if the conditions are not met
            }
            let is_primary = true;
            if (additional)
                is_primary = checkIfPrimary(cm)

            if (additional && FMFilter === "Non Critical") {
                if (checkIfPrimary(cm)) {
                    return <></>; // Return empty fragment if the control measure is primary
                }
            }
            if (additional && FMFilter === "Critical") {
                if (!checkIfPrimary(cm)) {
                    return <></>; // Return empty fragment if the control measure is primary
                }
            }




            return (
                <ReasonablyPracticableTest
                    control_types={controlTypes}
                    additional={additional}
                    comment_id={f.id || 0}
                    control_measure={cm}
                    control_measure_assessment={cma}
                    updateControlMeasureAssessment={updateControlMeasureAssessmentFinal}
                    updateControlMeasure={updateControlMeasure}
                    adequacies={adequacies}
                    is_primary={is_primary}
                />
            );
        });
    }, [controlMeasureFailureModes, controlMeasures, existing, additional, controlTypes, adequacies, f.id, updateControlMeasureAssessmentFinal, updateControlMeasure]);


    const handleTextChange = useCallback((event) => {
        let v = event.target.value
        let c = { ...currentFailureModeAssessment }
        c.assessment = v
        setCurrentFailureModeAssessment(c)
    }, [currentFailureModeAssessment]);


    const small_header = () => {
        return (<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', flexWrap: 'nowrap', gap: '8px' }}>
            {critical_hazard ? render_likelihood_pill(critical_hazard.max_annual_failure_probability, "Likelihood") : WarningChip("Likelihood")}
            {considered ? harm ? Consequence(harm, "Harm") : WarningChip("Harm") : ""}
            {harm ? harm.special_consideration ? WarningChip(harm.special_consideration, harm.special_consideration === "None" ? -1 : 2, "Special Consideration") : "" : ""}
            {considered ? APPLICATION === "ALARP" || settings?.consider_societal_concerns && (cc ? ControlConcern(cc, "Societal Concern") : WarningChip("Societal Concern")) : ""}

            {critical_hazard ? Confidence(critical_hazard, "societal_confidence_id",
                "Societal Risk") : WarningChip("Societal Risk")}
            {critical_hazard ? Confidence(critical_hazard, "individual_confidence_id",
                "Individual Risk") : WarningChip("Individual Risk")}
            {considered ? ec ? ControlAssessment(ec, "Improvement Opportunity") : WarningChip("Improvement Opportunity") : ""}
        </div>);
    }


    const complete_header = () => {
        return (


            <TableContainer>
                <Table>
                    <TableHead>
                        <TableCell colSpan={5}><b>Group Assessment - {f.failure_mode?.name}</b></TableCell>
                        <TableCell colSpan={1} style={{ display: 'flex', justifyContent: 'flex-end' }}>{expandedHeader ? (
                                            <ExpandLessIcon
                                                onClick={handleHeaderExpand}
                                                style={{ cursor: 'pointer' }}
                                            />
                                        ) : (
                                            <ExpandMoreIcon
                                                onClick={handleHeaderExpand}
                                                style={{ cursor: 'pointer' }}
                                            />
                                        )}</TableCell>
                    </TableHead>
                    <TableBody>
                        <TableRow>

                            <TableCell>Likelihood</TableCell>
                            <TableCell>Annual Failure Probability</TableCell>
                            <TableCell>{critical_hazard ? render_likelihood_pill(critical_hazard.max_annual_failure_probability) : ""}</TableCell>

                            {considered && <><TableCell>Controls</TableCell>
                                <TableCell>Improvement Opportunity</TableCell>
                                <TableCell> {ec ? ControlAssessment(ec) : WarningChip("undefined")}</TableCell></>}
                            {additional && <>
                                <TableCell colSpan={2}>Existing Control Measure Assessment</TableCell>
                            </>}
                        </TableRow>

                        <TableRow>
                            {considered && <><TableCell>Harm</TableCell>
                                <TableCell>Consequence Category</TableCell>
                                <TableCell>{harm ? Consequence(harm) : WarningChip("undefined")}</TableCell>

                            </>}
                            <TableCell>Confidence below LoT</TableCell>
                            <TableCell>Societal Risk</TableCell>
                            <TableCell>{critical_hazard ? Confidence(critical_hazard, "societal_confidence_id") :
                                WarningChip("undefined")}</TableCell>

                            {additional && <>
                                <TableCell colSpan={3} rowSpan={2}>

                                    <TextField
                                        style={{ width: '100%' }}
                                        inputProps={{ style: { fontSize: "11pt" } }}
                                        // id="standard-number"
                                        multiline={true}
                                        // disabled={!write_access}
                                        size={"small"}
                                        value={currentFailureModeAssessment?.assessment}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        onChange={(event) => {
                                            handleTextChange(event);
                                        }}
                                        onBlur={(event) => {
                                            let v = event.target.value;
                                            let c = { ...currentFailureModeAssessment };
                                            c.assessment = v;
                                            postFailureModeAssessment({ ...c });
                                        }} />
                                </TableCell>
                            </>}
                        </TableRow>

                        <TableRow>
                            {considered && <><TableCell></TableCell>
                                <TableCell>Special Consideration</TableCell>
                                <TableCell>
                                    <div style={{ maxWidth: "300px" }}>
                                        {harm ? harm.special_consideration ? WarningChip(harm.special_consideration, harm.special_consideration === "None" ? -1 : 2, "Special Consideration") : "-" : "-"}

                                        {harm ? harm.special_consideration_description ? harm.special_consideration_description : "-" : "-"}
                                    </div>
                                </TableCell>

                            </>}
                            <TableCell>Confidence below LoT</TableCell>
                            <TableCell>Individual Risk</TableCell>
                            <TableCell> {critical_hazard ? Confidence(critical_hazard, "individual_confidence_id") :
                                WarningChip("undefined")}</TableCell>
                        </TableRow>

                        {considered && (APPLICATION == "ALARP" || settings?.consider_societal_concerns) &&

                            <TableRow>
                                <TableCell>Societal Concern</TableCell>
                                <TableCell>Rating</TableCell>
                                <TableCell>{cc ? ControlConcern(cc) : WarningChip("undefined")}</TableCell>

                            </TableRow>}
                        {considered && <>
                            <TableRow>
                                <TableCell colSpan={1}>Failure Mode wide Justification </TableCell>
                                <TableCell colSpan={5}>

                                    <TextField
                                        style={{ width: '100%' }}
                                        inputProps={{ style: { fontSize: "11pt" } }}
                                        // id="standard-number"
                                        multiline={true}
                                        // disabled={!write_access}
                                        size={"small"}
                                        value={currentFailureModeAssessment?.assessment}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        onChange={(event) => {
                                            handleTextChange(event);
                                        }}
                                        onBlur={(event) => {
                                            let v = event.target.value;
                                            let c = { ...currentFailureModeAssessment };
                                            c.assessment = v;
                                            postFailureModeAssessment({ ...c });
                                        }} />
                                </TableCell>


                            </TableRow>
                        </>}

                    </TableBody>

                </Table>
            </TableContainer>
        )
    }

    return (
        <Accordion style={{ backgroundColor: "#f3f3f3" }} expanded={expanded === 'panel' + f.id} onChange={handleChange('panel' + f.id)} square>
            <AccordionSummary id={f.id?.toString()} expandIcon={<ExpandMore />}>

                <Typography variant="h6"> {f.failure_mode?.name} </Typography>
                {expanded !== 'panel' + f.id && small_header()
                }
            </AccordionSummary>
            <>
                <div style={{ position: 'sticky', top: 65, zIndex: 10, backgroundColor: "#f3f3f3" }}>
                <Grid container spacing={3} >
                {!expandedHeader && <Grid item xs={12}>
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableCell colSpan={6}><b>Group Assessment - {f.failure_mode?.name}</b></TableCell>
                                        <TableCell colSpan={3}>{ small_header()}</TableCell>
                                        <TableCell colSpan={1} style={{ display: 'flex', justifyContent: 'flex-end' }}>{expandedHeader ? (
                                            <ExpandLessIcon
                                                onClick={handleHeaderExpand}
                                                style={{ cursor: 'pointer' }}
                                            />
                                        ) : (
                                            <ExpandMoreIcon
                                                onClick={handleHeaderExpand}
                                                style={{ cursor: 'pointer' }}
                                            />
                                        )}</TableCell>
                                    </TableHead>
                                </Table>
                            </TableContainer>
                        </Grid>
                        }


                        {expandedHeader && <Grid item xs={12} >
                            {complete_header()}
                        </Grid>
                        }
                    </Grid>
                    <Typography variant="h6"></Typography>
                {additional && <Grid container spacing={3}>
                    <Grid item xs={12}>
                        {render_pill(4, "All", null)}
                        {render_pill(0, APPLICATION == "ALARP" ? "Priority" : "Critical", "Critical")}
                        {render_pill(2, APPLICATION == "ALARP" ? "Non Priority" : "Non Critical", "Non Critical")}
                    </Grid>
                </Grid>}
                </div>
                { control_view == false && <>
                <Table style={{ backgroundColor: "#FFFFFF" }}>
                    <TableHead style={{ position: 'sticky', top: expandedHeader && additional ? 340 : expandedHeader ? 375 : additional? 85: 75, zIndex: 2, backgroundColor: "#FFFFFF" }}>
                        <TableRow><TableCell colSpan={9}><><b>Control Measures</b>
                            {additional && write_access && <Tooltip title="Add Control Measure" placement={'bottom-end'}>
                                <AddingButton style={{
                                    backgroundColor: "rgb(239,88,43)",
                                    color: "rgb(255,255,255)"
                                }} onClick={prevState => handleOpen()}>
                                    <AddIcon fontSize="small" />
                                </AddingButton>
                            </Tooltip>}
                            {openCreateDialog && <AddControlMeasureDialog controlMeasure={{
                                uuid: -1,
                                description: "",
                                existing: existing,
                                control_type_id: 0
                            }} project_falure_mode_id={f.id} updateControlMeasure={updateControlMeasures} closeDialogCallback={handleClose} />}</>
                        </TableCell></TableRow>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Type</TableCell>
                            <TableCell width={30}>de Minimis?</TableCell>
                            <TableCell width={30}>Good Practice & Precedence </TableCell>
                            <TableCell width={30}>Order of magnitude of Costs ($M)</TableCell>
                            {!additional && <TableCell width={60}>Justification based on Cost (DF) </TableCell>}
                            <TableCell>Overall Assessment</TableCell>
                            <TableCell width={"40%"}>Justification</TableCell>
                            <TableCell >Investigation</TableCell>
                            <TableCell>Comments</TableCell>
                        </TableRow>
                    </TableHead>



                    {render_control_measure_assessment}
                </Table>
                {!additional &&
                    <div>
                        <Typography><small>Note only included or de minimis control measures are shown</small></Typography>
                    </div>
                }
                {additional &&
                    <div>
                        <Typography><small>Note only not included control measures are shown</small></Typography>
                    </div>
                }
            </> }
            </>
        </Accordion>

    )


}


